<template>
  <div>
    <el-card class="mb5">
      <el-form :inline="false" label-position="top" size="small">
        <el-row :gutter="20">
          <el-col :span="5">
            <!--  运单号   -->
            <el-form-item prop="selectType">
              <template slot="label">
                <div class="selectLabel">
                  <el-select v-model="queryForm.params.selectType" :style="IsWidth">
                    <el-option key="1" :label="$t('newOrder.waybillNumber')" :value="1" />
                    <el-option key="2" :label="$t('GlobalSetObj.ScanNumber')" :value="2" />
                  </el-select>
                </div>
              </template>
              <el-input
                v-model="queryForm.params.inputValue"
                :placeholder="$t('newOrder.PreciseSearch1')"
                :rows="1"
                style="width: 100%"
                type="textarea"
              />
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <!--上传时间-->
            <el-form-item prop="selectTimeType">
              <template slot="label">
                <div class="selectLabel">
                  <el-select v-model="queryForm.params.selectTimeType" :style="IsWidth01">
                    <el-option key="1" :label="$t('home.uploadTime')" :value="1" />
                    <el-option key="2" :label="$t('receivablePayable.ReviewTime')" :value="2" />
                    <el-option key="3" :label="$t('orderCenterCont.dueTime01')" :value="3" />
                  </el-select>
                </div>
              </template>
              <el-date-picker
                v-model="timeValue"
                :clearable="false"
                :default-time="['00:00:00', '23:59:59']"
                :format="$i18n.locale == 'zh' ? zhDate : ptDate"
                :placeholder="$t('newOrder.SelectDatetime')"
                range-separator="~"
                style="width: 100%"
                type="datetimerange"
                value-format="yyyy-MM-dd HH:mm:ss"
              />
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item :label="$t('GlobalSetObj.status')">
              <!--状态-->
              <el-select v-model="queryForm.params.forceType" style="width: 100%">
                <el-option key="0" :label="$t('GlobalSetObj.all')" value="" />
                <el-option key="1" :label="$t('Resource.underReviewNEW')" :value="1" />
                <el-option key="2" :label="$t('customerManagements.approved')" :value="2" />
                <el-option key="3" :label="$t('home.unapplivefail')" :value="3" />
                <el-option key="4" :label="$t('home.applivefail')" :value="4" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item :label="$t('collectionCenter.actualStorageRegion')">
              <el-select
                v-model="queryForm.params.regionId"
                :placeholder="$t('placeOrder.pleaseChoose')"
                clearable
                filterable
                style="width: 100%"
              >
                <el-option
                  v-for="item in regionList"
                  :key="item.id"
                  :label="item.zhName + '（' + item.puName + '）'"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <!--  网点所属州 -->
          <!--          <el-col :span="4">-->
          <!--            <el-form-item>-->
          <!--              <template slot="label">-->
          <!--                <div class="selectLabel">-->
          <!--                  <el-select v-model="queryForm.params.selectStateType" :style="IsWidth02">-->
          <!--                    <el-option key="1" :label="$t('navbar.actualDeliveryBranchState')" :value="1" />-->
          <!--                    <el-option key="2" :label="$t('GlobalSetObj.storageOutletsState')" :value="2" />-->
          <!--                  </el-select>-->
          <!--                </div>-->
          <!--              </template>-->
          <!--              <el-select-->
          <!--                v-model="queryForm.params.preState"-->
          <!--                :placeholder="$t('GlobalSetObj.pleaseChoose')"-->
          <!--                clearable-->
          <!--                filterable-->
          <!--                multiple-->
          <!--                style="width: 100%"-->
          <!--              >-->
          <!--                <el-option-->
          <!--                  v-for="item in StateList"-->
          <!--                  :key="item.id"-->
          <!--                  :label="item.label"-->
          <!--                  :value="item.label"-->
          <!--                />-->
          <!--              </el-select>-->
          <!--            </el-form-item>-->
          <!--          </el-col>-->
          <!-- 实际派送网点 -->
          <el-col :span="4">
            <el-form-item>
              <template slot="label">
                <div class="selectLabel">
                  <el-select v-model="queryForm.params.selectSiteType" :style="IsWidth02">
                    <el-option key="1" :label="$t('GlobalSetObj.entrega')" :value="1" />
                    <el-option key="2" :label="$t('GlobalSetObj.storageOutlets')" :value="2" />
                  </el-select>
                </div>
              </template>
              <el-select
                v-model="queryForm.params.deliverSiteId"
                :placeholder="$t('GlobalSetObj.pleaseChoose')"
                clearable
                filterable
                multiple
                style="width: 100%"
              >
                <el-option
                  v-for="item in siteList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <!-- 派送员 -->
          <el-col :span="4">
            <el-form-item :label="$t('orderCenterCont.deliveryPerson')">
              <el-select
                v-model="queryForm.params.delivererId"
                :placeholder="$t('GlobalSetObj.pleaseChoose')"
                :remote-method="getallDriver"
                clearable
                filterable
                multiple
                remote
                reserve-keyword
                style="width: 100%"
                @focus="getallDriver(seachDriver)"
              >
                <el-option
                  v-for="item in userList"
                  :key="item.id"
                  :label="item.username"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item :label="$t('newOrder.waybillStatus')">
              <el-select
                v-model="queryForm.params.waybillStatus"
                :placeholder="$t('GlobalSetObj.all')"
                clearable
                collapse-tags
                filterable
                multiple
                style="width: 100%"
              >
                <el-option
                  v-for="(item, ind) in waybillStatusList"
                  :key="ind"
                  :label="item.label"
                  :value="item.code"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <!--    类型      -->
            <el-form-item :label="$t('Resource.taskType')">
              <el-select
                v-model="queryForm.params.signatureType"
                :placeholder="$t('GlobalSetObj.all')"
                clearable
                style="width: 100%"
              >
                <el-option key="1" :label="$t('Resource.outOfRange')" :value="1" />
                <el-option key="2" :label="$t('Resource.offlineSigning')" :value="2" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <!--    AI审核     -->
            <el-form-item :label="$t('home.aiAudit')">
              <el-select
                v-model="queryForm.params.aiAuditFlag"
                :placeholder="$t('GlobalSetObj.all')"
                clearable
                collapse-tags
                filterable
                multiple
                style="width: 100%"
              >
                <el-option key="0" :label="$t('home.aiAuditUnreviewed')" :value="0" />
                <el-option key="1" :label="$t('home.aiAuditReviewed')" :value="1" />
                <el-option key="2" :label="$t('home.aiAuditExempt')" :value="2" />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <div style="margin-bottom: 15px">
              <!--搜索-->
              <el-button
                icon="el-icon-search" size="small" type="primary"
                @click="enterSearch"
              >{{ $t('newOrder.search') }}
              </el-button>
              <!--重置-->
              <el-button
                icon="el-icon-refresh-left" size="small" type="info"
                @click="resetForm"
              >{{ $t('newOrder.reset') }}
              </el-button>
              <!--导出-->
              <el-button size="small" @click="allExportOrder">{{ $t('newOrder.export') }}
              </el-button>
              <!--催办-->
              <el-button
                v-permit:remove="'btn:qualityService:signatureVerification:UrgeToDo'"
                size="small"
                type="primary"
                @click="UrgeToDo"
              >{{ $t('changepwd.UrgeToDo') }}
              </el-button>
              <!--  批量审核功能  -->
              <el-button
                v-permit:remove="'btn:qualityService:signatureVerification:batchReviewFunction'"
                size="small"
                type="primary"
                @click="batchReviewFunction"
              >{{ $t('home.batchReview') }}
              </el-button>
            </div>
          </el-col>
        </el-row>
      </el-form>
    </el-card>
    <!--  表格数据  -->
    <el-card>
      <el-table
        :data="tableData"
        :header-cell-style="{ background: '#f2f2f2', color: 'black' }"
        border
        style="width: 100%"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55" />
        <el-table-column
          :label="$t('GlobalSetObj.serial')"
          align="center"
          fixed="left"
          type="index"
          width="80"
        />
        <el-table-column
          v-for="(item, index) in tableHeaderList"
          :key="index"
          :align="item.cloCenter"
          :label="item.label"
          :min-width="item.cloWidth"
          :prop="item.prop"
        >
          <template slot-scope="scope">
            <div v-if="item.prop === 'signedPhoto'">
              <div class="verifier" @click="imageSee(scope.row.signedPhoto)">
                {{ scope.row.signedPhoto ? $t('home.clickSee') : '--' }}
              </div>
            </div>
            <div v-else-if="item.prop === 'signedNamePhoto'">
              <div class="verifier" @click="imageSee(scope.row.signedNamePhoto)">
                {{ scope.row.signedNamePhoto ? $t('home.clickSee') : '--' }}
              </div>
            </div>
            <div v-else-if="item.prop === 'forceType'">
              <el-tag v-if="scope.row.forceType === 1" type="warning">{{ $t('Resource.underReviewNEW') }}
              </el-tag>
              <el-tag v-else-if="scope.row.forceType === 2" type="success">{{ $t('customerManagements.approved') }}
              </el-tag>
              <el-tag v-else-if="scope.row.forceType === 4" type="danger">{{ $t('home.applivefail') }}
              </el-tag>
              <el-tag v-else type="danger">{{ $t('home.unapplivefail') }}</el-tag>
            </div>
            <div v-else>{{ scope.row[item.prop] ? `${scope.row[item.prop]}` : '--' }}</div>
          </template>
        </el-table-column>
        <el-table-column
          :label="$t('GlobalSetObj.operate')"
          align="center"
          fixed="right"
          min-width="110"
          prop="varianceNumber"
        >
          <template slot-scope="scope">
            <div v-if="scope.row.forceType !== 2">
              <div
                v-if="scope.row.forceType !== 2 && scope.row.waybillStatus !== 10"
                class="audit-btn"
                @click="seeDetial(scope.row)"
              >
                {{ $t('Resource.Approval') }}
              </div>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <!--  分页  -->
      <el-pagination
        :current-page="queryForm.pageNumber"
        :page-size="queryForm.pageSize"
        :page-sizes="[10, 20, 50, 100]"
        :total="queryForm.total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        style="margin: 10px 0; float: right"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </el-card>
    <!--签收审核（左侧待审核列表 + 右侧审核详情）-->
    <el-drawer
      :append-to-body="true"
      :title="$t('home.signReview')"
      :visible.sync="waybillDescription"
      custom-class="drawerClass"
      direction="ltr"
      size="90%"
      @close="handleDrawerClose"
    >
      <div style="height: 100%; overflow: hidden">
        <detailPage
          v-if="waybillDescription"
          :current-id="rowData.id"
          :list="tableData"
          @call-parent-method="parentMethod"
        />
      </div>
    </el-drawer>
    <!-- 图片弹框   -->
    <el-dialog
      :append-to-body="true"
      :close-on-click-modal="false"
      :show-close="true"
      :title="$t('navbar.seeImage')"
      :visible.sync="dialogVisible"
      top="3vh"
      width="540px"
    >
      <div>
        <div v-if="imageList.length > 0" style="width: 500px">
          <div style="text-align: center; color: #00a551; font-size: 18px">
            <span>{{ currentIndex + 1 }}</span>
            <span>/</span>
            <span>{{ imageList.length }}</span>
          </div>
          <el-carousel
            ref="carousel" height="750px" trigger="click"
            @change="handlecarousel"
          >
            <el-carousel-item v-for="item in imageList" :key="item">
              <div style="margin-left: 10px">
                <el-image
                  :preview-src-list="[item]"
                  :src="item"
                  fit="fill"
                  style="width: 100%; height: 700px"
                />
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
        <div v-else style="width: 500px; text-align: center; height: 750px">
          <el-image style="width: 100%">
            <div slot="error" class="image-slot">
              <i class="el-icon-picture-outline" style="font-size: 30px" />
            </div>
          </el-image>
        </div>
      </div>
    </el-dialog>
    <!--  操作结果 -->
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :title="$t('GlobalSetObj.tips')"
      :visible.sync="tipDialog1"
      width="580px"
    >
      <div class="flx-between" style="font-size: 16px">
        <div>
          {{ $t('home.operationTotal') }}:<span class="tipclass">{{
            resultsObj.operateTotal
          }}</span>
        </div>
        <div>
          {{ $t('operationCenter.NumberOfSuccesses') }}:<span class="tipclass">{{
            resultsObj.operateSuccesses
          }}</span>
        </div>
        <div>
          {{ $t('operationCenter.NumberOfFailures') }}:<span class="tipclass" style="color: red">{{
            resultsObj.operateFailures
          }}</span>
        </div>
      </div>
      <div
        v-if="resultsObj.operateFailures"
        style="
          margin-top: 15px;
          font-size: 16px;
          line-height: 30px;
          height: 200px;
          overflow-y: auto;
        "
      >
        <div>{{ $t('GlobalSetObj.ReasonForFailure') }}:</div>
        <div v-for="(item, index) in resultsObj.remindersDetailsVOList" :key="index">
          <span>{{ index + 1 }}.</span>
          <span>{{ item.reason }}</span>
        </div>
      </div>
      <div style="text-align: center; margin-top: 20px">
        <el-button size="small" type="primary" @click="tipDialog1 = false">{{ $t('GlobalSetObj.determine') }}
        </el-button>
      </div>
    </el-dialog>
    <!--  批量审核功能  -->
    <batchReviewwResult ref="batchReviewwResultRef" @call-parent-method="handleBatchReviewed" />
  </div>
</template>

<script>
import {
  getLgAreaListData,
  lgStorageForceSignpage,
  regionQueryList,
  selectInfoByStateTwo
} from '@/api/orderApi';
import detailPage from './component/detail.vue';
import dayjs from 'dayjs';
import { signRescissiongetPmUserList } from '@/api/resources';
import { waybillStatusList } from '@/utils/enumData';
import { lgStorageForceSignexport, lgStorageForceSignReminders } from '@/api/newExpressAPI';
import { goResourceTaskList } from '@/utils/goExportList';
import { Loading } from 'element-ui';
import batchReviewwResult from './component/batchReviewwResult.vue';

export default {
  name: 'MandatorySignatureVerification',
  components: {
    detailPage,
    batchReviewwResult
  },
  data() {
    return {
      allSiteListCache: null, // 全部网点数据缓存
      sitesByRegionAndState: {},
      regionList: [],
      // 详情
      waybillDescription: false,
      detailKey: new Date().getTime(),
      // 是否格式化成巴西时间
      isTormat: false,
      zhDate: 'yyyy-MM-dd HH:mm:ss',
      ptDate: 'dd-MM-yyyy HH:mm:ss',
      timeValue: [],
      queryForm: {
        pageSize: 10,
        pageNumber: 1,
        total: 0,
        params: {
          inputValue: '',
          selectType: 1,
          // selectStateType: 2,
          selectTimeType: 1,
          selectSiteType: 2,
          // preState: [],
          deliverSiteId: [],
          delivererId: [],
          forceType: '',
          waybillStatus: [],
          signatureType: '',
          aiAuditFlag: [],
          regionId: null
        }
      },
      tableData: [],
      tableHeaderList: [
        {
          label: this.$t('newOrder.waybillNumber'),
          prop: 'waybillNumber',
          cloWidth: 160,
          cloCenter: 'center'
        },
        {
          label: this.$t('GlobalSetObj.ScanNumber'),
          prop: 'scanOrderNumber',
          cloWidth: 160,
          cloCenter: 'center'
        },
        {
          label: this.$t('GlobalSetObj.status'),
          prop: 'forceType',
          cloWidth: 150,
          cloCenter: 'center'
        },
        {
          label: this.$t('home.aiAudit'),
          prop: 'aiAuditFlagName',
          cloWidth: 150,
          cloCenter: 'center'
        },
        {
          label: this.$t('receivablePayable.ReasonForFailure01'),
          prop: 'reasonDesc',
          cloWidth: 150,
          cloCenter: 'center'
        },
        {
          label: this.$t('home.seesingPhoto'),
          prop: 'signedPhoto',
          cloWidth: 160,
          cloCenter: 'center'
        },
        {
          label: this.$t('home.ViewSignature'),
          prop: 'signedNamePhoto',
          cloWidth: 150,
          cloCenter: 'center'
        },
        {
          label: this.$t('newOrder.waybillStatus'),
          prop: 'waybillStatusName',
          cloWidth: 160,
          cloCenter: 'center'
        },
        {
          label: this.$t('Resource.taskType'),
          prop: 'signatureTypeName',
          cloWidth: 160,
          cloCenter: 'center'
        },
        {
          label: this.$t('orderCenterCont.dueTime01'),
          prop: 'expectedDeliveredTime',
          cloWidth: 160,
          cloCenter: 'center'
        },
        {
          // 大区 Região
          label: this.$t('collectionCenter.region'),
          prop: 'regionName',
          cloWidth: 100,
          cloCenter: 'center'
        },
        {
          label: this.$t('GlobalSetObj.storageOutletsState'),
          prop: 'warehouseStationState',
          cloWidth: 160,
          cloCenter: 'center'
        },
        {
          label: this.$t('GlobalSetObj.storageOutlets'),
          prop: 'warehouseStationName',
          cloWidth: 160,
          cloCenter: 'center'
        },
        {
          label: this.$t('navbar.actualDeliveryBranchState'),
          prop: 'preState',
          cloWidth: 110,
          cloCenter: 'center'
        },
        {
          label: this.$t('GlobalSetObj.entrega'),
          prop: 'deliverSiteIdName',
          cloWidth: 150,
          cloCenter: 'center'
        },
        {
          label: this.$t('orderCenterCont.deliveryPerson'),
          prop: 'delivererName',
          cloWidth: 120,
          cloCenter: 'center'
        },
        {
          label: this.$t('home.uploadTime'),
          prop: 'uploadTime',
          cloWidth: 160,
          cloCenter: 'center'
        },
        {
          label: this.$t('Resource.Reviewer'),
          prop: 'approverName',
          cloWidth: 160,
          cloCenter: 'center'
        },
        {
          label: this.$t('receivablePayable.ReviewTime'),
          prop: 'approverTime',
          cloWidth: 160,
          cloCenter: 'center'
        }
      ],
      dialogVisible: false,
      imageList: [],
      currentIndex: 0,
      rowData: {},
      StateList: [], // 州
      siteList: [],
      userList: [],
      searchsiteStr: '',
      seachDriver: '',
      waybillStatusList: waybillStatusList,
      selectDataList: [],
      tipDialog1: false,
      resultsObj: {},
      // 定时器相关
      refreshTimer: null,
      refreshCount: 0
    };
  },
  computed: {
    IsWidth() {
      return {
        width: this.isTormat ? '180px' : '100px'
      };
    },
    IsWidth01() {
      return {
        width: this.isTormat ? '210px' : '130px'
      };
    },
    IsWidth02() {
      return {
        width: this.isTormat ? '210px' : '150px'
      };
    }
  },
  watch: {
    regionList: {
      deep: true,
      handler(newVal) {
        if (newVal.length > 0) {
          this.groupSitesByRegionAndState();
        }
      }
    },
    'queryForm.params.regionId'(newVal) {
      this.queryForm.params.preState = [];
      this.queryForm.params.deliverSiteId = [];
      if (newVal && this.regionList.length > 0) {
        const selectedRegion = this.regionList.find((item) => item.id === newVal);
        if (selectedRegion && Array.isArray(selectedRegion.states)) {
          this.StateList = selectedRegion.states.map((state) => ({
            label: state
          }));
        }
        this.siteList = selectedRegion?.sites || [];
        this.groupSitesByRegionAndState();
      } else {
        this.StateList = [];
        this.getAddress();
        this.siteList = [];
        this.remoteGetSiteList();
      }
    }
  },
  created() {
    if (this.$i18n.locale !== 'zh') {
      this.isTormat = true;
    }
    this.getTimer();
    this.getSearch();
    this.getAddress();
    this.remoteGetSiteList();
    this.getRegion();
  },
  // 页面销毁时清除定时器（必加，防止bug）
  beforeDestroy() {
    if (this.refreshTimer) {
      clearInterval(this.refreshTimer);
    }
  },
  methods: {
    // 大区
    getRegion() {
      regionQueryList(1).then((res) => {
        if (res.code === 200) {
          this.regionList = res.data;
        }
      });
    },
    groupSitesByRegionAndState() {
      const grouped = {};
      this.regionList.forEach((region) => {
        if (!grouped[region.id]) {
          grouped[region.id] = {};
        }

        region.sites.forEach((site) => {
          const key = site.state; // 区分大小写
          if (!grouped[region.id][key]) {
            grouped[region.id][key] = [];
          }
          grouped[region.id][key].push(site);
        });
      });

      this.sitesByRegionAndState = grouped;
    },
    handleSelectionChange(val) {
      this.selectDataList = val;
    },
    // 催办
    UrgeToDo() {
      if (this.selectDataList.length === 0) {
        this.$message.error(this.$t('collectionCenter.pleaseSelectData'));
        return;
      }
      const idList = [];
      this.selectDataList.forEach((item) => {
        idList.push(item.id);
      });
      lgStorageForceSignReminders({ idList }).then((res) => {
        if (res.code === 200) {
          this.resultsObj = res.data;
          this.tipDialog1 = true;
          this.getSearch();
        }
      });
    },
    // 批量审核功能
    batchReviewFunction() {
      if (this.selectDataList.length === 0) {
        this.$message.error(this.$t('collectionCenter.pleaseSelectData'));
        return;
      }
      if (this.selectDataList.length > 10) {
        this.$message.error(this.$t('scripting.batchReviewLimit'));
        return;
      }
      this.$refs.batchReviewwResultRef.clickBatchReviewDialog(this.selectDataList);
    },
    handlecarousel(val) {
      this.currentIndex = val;
    },
    // 点击审核：打开签收审核抽屉（列表数据在抽屉内左侧展示）
    seeDetial(row) {
      this.detailKey = new Date().getTime();
      this.rowData = row;
      this.waybillDescription = true;
    },
    // 抽屉内只通知父级控制显隐，刷新统一由抽屉的 @close 触发，避免重复查询
    parentMethod(arg) {
      this.waybillDescription = arg;
    },
    // 批量审核完成后刷新列表
    handleBatchReviewed() {
      this.getSearch();
    },
    // 抽屉关闭后刷新分页（覆盖点 X、遮罩、ESC、关闭按钮等所有关闭方式）
    handleDrawerClose() {
      this.getSearch();
    },
    // 点击查看 图片
    imageSee(data) {
      if (data && data.length > 0) {
        this.imageList = data.map((item) => {
          return item + '?imageMogr2/thumbnail/2000x2000>/quality/80/format/jpg/ignore-error/1';
        });
        this.dialogVisible = true;
      }
    },
    enterSearch() {
      this.queryForm.pageNumber = 1;
      this.getSearch();
    },
    // 重置
    resetForm() {
      this.queryForm.pageNumber = 1;
      this.getTimer();
      this.queryForm.params = {
        inputValue: '',
        selectType: 1,
        // selectStateType: 1,
        selectTimeType: 1,
        selectSiteType: 1,
        // preState: [],
        deliverSiteId: [],
        delivererId: [],
        forceType: '',
        waybillStatus: [],
        signatureType: '',
        aiAuditFlag: [],
        regionId: null
      };
      this.searchsiteStr = '';
      this.seachDriver = '';
      this.siteList = [];
      this.userList = [];
      this.getSearch();
      this.remoteGetSiteList();
    },
    // 导出
    allExportOrder() {
      let inputValList = [];
      if (this.queryForm.params.inputValue) {
        inputValList = this.queryForm.params.inputValue.split('\n');
      }
      const data = {
        waybillNumberList: [],
        scanOrderNumberList: [],
        delivererId: this.queryForm.params.delivererId,
        deliverSiteId: [],
        warehouseStationIdList: [],
        // preState: [],
        warehouseStationStateList: [],
        forceType: this.queryForm.params.forceType,
        waybillStatus: this.queryForm.params.waybillStatus,
        signatureType: this.queryForm.params.signatureType,
        aiAuditFlag: this.queryForm.params.aiAuditFlag,
        uploadStartTime: '',
        uploadEndTime: '',
        approverStartTime: '',
        approverEndTime: '',
        expectedDeliveredStartTime: '',
        expectedDeliveredEndTime: '',
        regionId: this.queryForm.params.regionId
      };
      if (this.timeValue && this.timeValue.length > 0) {
        // 1. 用 day.js 解析开始/结束时间（自动兼容常见时间格式：YYYY-MM-DD、YYYY-MM-DD HH:mm:ss 等）
        const startTime = dayjs(this.timeValue[0]);
        const endTime = dayjs(this.timeValue[1]);
        // 2. 精准校验：时间范围是否超过7天（604800000毫秒 = 7*24*60*60*1000）
        const sevenDaysMs = 7 * 24 * 60 * 60 * 1000; // 7天的毫秒数
        const timeDiffMs = endTime.diff(startTime); // 计算两个时间的毫秒差
        if (timeDiffMs > sevenDaysMs) {
          this.$message.error(this.$t('home.timeRangeLimit7Days'));
          return; // 终止赋值逻辑
        }
        if (this.queryForm.params.selectTimeType === 1) {
          data.uploadStartTime = this.timeValue[0];
          data.uploadEndTime = this.timeValue[1];
        } else if (this.queryForm.params.selectTimeType === 2) {
          data.approverStartTime = this.timeValue[0];
          data.approverEndTime = this.timeValue[1];
        } else {
          data.expectedDeliveredStartTime = this.timeValue[0];
          data.expectedDeliveredEndTime = this.timeValue[1];
        }
      } else if (
        (!this.timeValue || this.timeValue.length <= 0) &&
        !this.queryForm.params.inputValue
      ) {
        this.$message.warning(this.$t('GlobalSetObj.selectTime'));
        return;
      }
      if (this.queryForm.params.selectType === 1) {
        data.waybillNumberList = inputValList;
      } else {
        data.scanOrderNumberList = inputValList;
      }
      // if (this.queryForm.params.selectStateType === 1) {
      //   data.preState = this.queryForm.params.preState;
      // } else {
      //   data.warehouseStationStateList = this.queryForm.params.preState;
      // }
      if (this.queryForm.params.selectSiteType === 1) {
        data.deliverSiteId = this.queryForm.params.deliverSiteId;
      } else {
        data.warehouseStationIdList = this.queryForm.params.deliverSiteId;
      }
      lgStorageForceSignexport(data).then((res) => {
        if (res.code === 200) {
          goResourceTaskList();
        }
      });
    },
    // 查询
    getSearch() {
      let inputValList = [];
      if (this.queryForm.params.inputValue) {
        inputValList = this.queryForm.params.inputValue.split('\n');
      }
      if (inputValList.length > 2000) {
        this.$message.warning(this.$t('newOrder.searchMax1000'));
        inputValList = inputValList.slice(0, 2000); // 截取前2000个单号
      }
      const data = {
        pageSize: this.queryForm.pageSize,
        pageNumber: this.queryForm.pageNumber,
        params: {
          waybillNumberList: [],
          scanOrderNumberList: [],
          delivererId: this.queryForm.params.delivererId,
          deliverSiteId: [],
          warehouseStationIdList: [],
          // preState: [],
          warehouseStationStateList: [],
          forceType: this.queryForm.params.forceType,
          signatureType: this.queryForm.params.signatureType,
          aiAuditFlag: this.queryForm.params.aiAuditFlag,
          waybillStatus: this.queryForm.params.waybillStatus,
          uploadStartTime: '',
          uploadEndTime: '',
          approverStartTime: '',
          approverEndTime: '',
          expectedDeliveredStartTime: '',
          expectedDeliveredEndTime: '',
          regionId: this.queryForm.params.regionId
        }
      };
      // if (this.queryForm.params.selectStateType === 1) {
      //   data.params.preState = this.queryForm.params.preState;
      // } else {
      //   data.params.warehouseStationStateList = this.queryForm.params.preState;
      // }
      if (this.queryForm.params.selectSiteType === 1) {
        data.params.deliverSiteId = this.queryForm.params.deliverSiteId;
      } else {
        data.params.warehouseStationIdList = this.queryForm.params.deliverSiteId;
      }
      if (this.timeValue && this.timeValue.length > 0) {
        // 1. 用 day.js 解析开始/结束时间（自动兼容常见时间格式：YYYY-MM-DD、YYYY-MM-DD HH:mm:ss 等）
        const startTime = dayjs(this.timeValue[0]);
        const endTime = dayjs(this.timeValue[1]);
        // 2. 精准校验：时间范围是否超过7天（604800000毫秒 = 7*24*60*60*1000）
        const sevenDaysMs = 7 * 24 * 60 * 60 * 1000; // 7天的毫秒数
        const timeDiffMs = endTime.diff(startTime); // 计算两个时间的毫秒差
        if (timeDiffMs > sevenDaysMs) {
          this.$message.error(this.$t('home.timeRangeLimit7Days'));
          return; // 终止赋值逻辑
        }
        if (this.queryForm.params.selectTimeType === 1) {
          data.params.uploadStartTime = this.timeValue[0];
          data.params.uploadEndTime = this.timeValue[1];
        } else if (this.queryForm.params.selectTimeType === 2) {
          data.params.approverStartTime = this.timeValue[0];
          data.params.approverEndTime = this.timeValue[1];
        } else {
          data.params.expectedDeliveredStartTime = this.timeValue[0];
          data.params.expectedDeliveredEndTime = this.timeValue[1];
        }
      } else if (
        (!this.timeValue || this.timeValue.length <= 0) &&
        !this.queryForm.params.inputValue
      ) {
        this.$message.warning(this.$t('GlobalSetObj.selectTime'));
        return;
      }
      if (this.queryForm.params.selectType === 1) {
        data.params.waybillNumberList = inputValList;
      } else {
        data.params.scanOrderNumberList = inputValList;
      }
      lgStorageForceSignpage(data).then((res) => {
        if (res.code === 200) {
          this.queryForm.total = res.data.total;
          this.tableData = res.data.records;
        }
      });
    },
    // 点击分页
    handleSizeChange(val) {
      this.queryForm.pageSize = val;
      this.queryForm.pageNumber = 1;
      this.getSearch();
    },
    handleCurrentChange(val) {
      this.queryForm.pageNumber = val;
      this.getSearch();
    },
    // 获取最近一星期时间
    getTimer() {
      const day = new Date();
      const brazilTime = day.toLocaleString('en-US', { timeZone: 'America/Sao_Paulo' });
      const today = dayjs(brazilTime).format('YYYY-MM-DD');
      const oneWeekAgo = dayjs(brazilTime).subtract(2, 'day').format('YYYY-MM-DD');
      this.timeValue = [oneWeekAgo + ' 00:00:00', today + ' 23:59:59'];
    },
    /**
     * @description 分页查询网点列表
     */
    remoteGetSiteList() {
      if (this.allSiteListCache) {
        this.siteList = this.allSiteListCache;
        return Promise.resolve();
      }
      const load = Loading.service({
        fullscreen: true,
        lock: true,
        spinner: 'el-icon-loading',
        text: this.$t('collectionCenter.loading'),
        background: 'rgba(250, 250, 250, 0.6)'
      });
      const data = {};
      // this.searchsiteStr = value;
      selectInfoByStateTwo(data)
        .then((res) => {
          if (res.code === 200) {
            this.allSiteListCache = res.data.siteList; // 缓存全部网点
            this.siteList = [...this.allSiteListCache]; // 初始化为全量数据
            load.close();
          }
        })
        .finally(() => {
          load.close();
        });
    },
    // 获取派送员
    getallDriver(name) {
      const data = {
        operateUserName: name
      };
      this.seachDriver = name;
      signRescissiongetPmUserList(data).then((res) => {
        if (res.code === 200) {
          this.userList = res.data;
        }
      });
    },
    // 州
    getAddress() {
      const params = {
        level: 0,
        parentId: ''
      };
      getLgAreaListData(params, false).then((res) => {
        if (res.code === 200) {
          this.StateList = res.data.map((item) => {
            return {
              id: item.id,
              label: `${item.nameEn}`
            };
          });
        }
      });
    }
  }
};
</script>

<style scoped>
.app-container >>> .drawerClass header {
  border-bottom: 1px solid #ccc !important;
  margin-bottom: 0 !important;
  padding: 20px 20px 20px !important;
}

.app-container >>> .el-form--label-top .el-form-item__label {
  width: 100% !important;
}

.app-container >>> .selectLabel .el-input__inner {
  height: 28px !important;
  line-height: 28px !important;
  border: none;
  font-weight: bold;
  text-align: left;
  padding: 0;
}

.app-container >>> .selectLabel .el-input__icon {
  line-height: 28px !important;
}

.selectType ::v-deep.el-input--suffix .el-input__inner {
  border: none !important;
  font-weight: bold;
  font-size: 14px;
  text-align: left;
}

.verifier {
  color: #00a551;
  cursor: pointer;
  padding: 0;
  font-size: 14px;
}

.audit-btn {
  display: inline-block; /* 让 div 像按钮一样根据内容撑开宽度 */
  padding: 5px 10px; /* 上下 7px，左右 20px，可根据实际需求微调 */
  border: 1px solid #00a551; /* 绿色边框，颜色取自图片 */
  border-radius: 4px; /* 圆角，还原图片的柔和边缘 */
  color: #00a551; /* 字体颜色与边框一致 */
  font-size: 12px; /* 字体大小，根据原 el-button size="small" 估算 */
  text-align: center;
  cursor: pointer; /* 鼠标悬浮时显示手型 */
  background-color: transparent; /* 背景透明 */
  user-select: none; /* 防止双击选中文字，提升按钮手感 */
  transition: all 0.2s; /* 添加过渡效果，让交互更平滑 */
}
</style>
